export const social = [
    { nombre: 'Donaciones', link: 'donacion', icono: 'ri:bank-fill' },
    { nombre: 'Facebook', link: 'https://www.facebook.com/MedellinAmiga', icono: 'stash:social-facebook-solid' },
    { nombre: 'Whatsapp', link: 'https://wa.link/o8yhic', icono: 'stash:social-whatsapp-solid' },
    { nombre: 'Instagram', link: 'https://www.instagram.com/fmedellinamiga/', icono: 'ri:instagram-fill' },
    { nombre: 'Mail', link: '', icono: 'material-symbols:mail-sharp' },
]